var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Header'),_c('HeaderMobileAside'),(_vm.userProfile && !_vm.userProfile.email_activation)?_c('div',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.$t('An email has been sent to you to activate your account.'))+" ")]):_vm._e(),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }